import { Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import scrollLock from 'scroll-lock';
import * as i0 from "@angular/core";
// import * as ModalActions from '@ibe/store/actions/modal.actions';
// import { Store } from '@ngrx/store';
// import * as fromStore from '../../../store';
var ModalService = /** @class */ (function () {
    function ModalService( /*private store: Store<fromStore.State>*/) {
        this.htmlElement = document.getElementsByTagName('html');
        this.navigateAwaySelection$ = new Subject();
        this.isOpen = new BehaviorSubject(false);
        this.$data = new BehaviorSubject(false);
        this.hostedComponent = new BehaviorSubject(null);
        this.params = null;
    }
    ModalService.prototype.assignComponent = function (component) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        this.params = params;
        this.hostedComponent.next(component);
    };
    ModalService.prototype.open = function () {
        this.isOpen.next(true);
        // Disable scroll on body
        this.htmlElement[0].classList.add('no-scroll');
        scrollLock.hide();
    };
    ModalService.prototype.close = function (data) {
        if (data === void 0) { data = false; }
        // this.store.dispatch(new ModalActions.ResetAction());
        this.$data.next(data);
        this.isOpen.next(false);
        this.hostedComponent.next(null);
        // Enable scroll on body again
        this.htmlElement[0].classList.remove('no-scroll');
        scrollLock.clearQueue().show();
    };
    // added to handle business logic that needs to happen via callback passed into params
    ModalService.prototype.handleOverlayClick = function () {
        if (this.params && this.params[0] && this.params[0].handleOverlayClick) {
            this.params[0].handleOverlayClick();
        }
    };
    ModalService.ngInjectableDef = i0.defineInjectable({ factory: function ModalService_Factory() { return new ModalService(); }, token: ModalService, providedIn: "root" });
    return ModalService;
}());
export { ModalService };
